var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('footer',[_c('span',[_vm._v("关于我们")]),_c('span',{staticClass:"company"},[_vm._v("成都壹石新科信息技术有限公司技术支持")]),_c('span',[_vm._v("四川省成都市高新区天府软件园B区B7栋6层")]),_c('span',[_vm._v("联系电话：4000838919")])])])
}]

export { render, staticRenderFns }